// Assets/warehousestocklevels.js
(async () => {
  const cfg = window.WSL; // injected via Liquid
  if (
    !cfg ||
    !cfg.productHandle ||
    !cfg.baseUrl ||
    !cfg.messages ||
    !cfg.priority
  ) {
    console.warn("warehouse-stock-levels: missing configuration", cfg);
    return;
  }

  console.log(`Fetching inventory from ${cfg.baseUrl}/inventory?handle=${cfg.productHandle}`);
  const inventoryMap = new Map();
  try {
    const res = await fetch(`${cfg.baseUrl}/inventory?handle=${cfg.productHandle}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const { inventory } = await res.json();
    console.log("Inventory payload:", inventory);
    inventory.forEach(v => {
      inventoryMap.set(String(v.variantId), v.levels);
    });
  } catch (e) {
    console.error("Failed to fetch inventory:", e);
    return;
  }

  // Expose for console inspection
  window.WSLinventoryMap = inventoryMap;
  window.printWSLInventory = () => {
    console.log("🏭 Warehouse inventory by variant:");
    inventoryMap.forEach((levels, variantId) => {
      console.log(`• Variant ${variantId}:`, levels);
    });
  };
  window.printSelectedVariantStock = () => {
    const vid = getSelectedVariantId();
    console.log(`🔎 Stock for selected variant ${vid}:`, inventoryMap.get(vid) || []);
  };

  // Utility to figure out which variant is active
  function getSelectedVariantId() {
    // 1) Shopify default hidden/input
    const formVariant = document.querySelector('select[name="id"], input[name="id"]');
    if (formVariant && formVariant.value) {
      return formVariant.value;
    }
    // 2) Fallback to your data-variant-id radios/buttons
    const active =
      document.querySelector("[data-variant-id]:checked") ||
      document.querySelector("[data-variant-id].active") ||
      document.querySelector("[data-variant-id]");
    return active ? active.getAttribute("data-variant-id") : null;
  }

  // Build your message based on priority locations
  function messageForVariant(variantId) {
    const levels = inventoryMap.get(String(variantId)) || [];
    for (let loc of cfg.priority) {
      const lvl = levels.find(l => l.location === loc && l.available > 0);
      if (lvl) {
        return cfg.messages[`message_${loc.replace(/\s+/g, "_").toLowerCase()}`] || "";
      }
    }
    return "Out of stock";
  }

  // Style & grab container
  const container = document.getElementById("warehouse-stock-level");
  if (!container) {
    console.warn("#warehouse-stock-level container not found");
    return;
  }
  Object.assign(container.style, {
    borderLeft: "4px solid rgb(240, 101, 3)",
    padding: "10px",
    backgroundColor: "rgba(240, 101, 3, 0.09)",
    fontFamily: "sans-serif",
    fontSize: "0.95em",
    color: "rgb(28, 29, 29)",
  });

  // Update display
  function updateForActiveVariant() {
    const vid = getSelectedVariantId();
    if (!vid) return;
    const msg = messageForVariant(vid);
    container.innerHTML = `<h3 style="margin:0 0 .5em;font-size:1.1em;font-weight:normal;">${msg}</h3>`;
  }

  // Wire up all relevant change events
  // - Shopify’s variant select/input
  // - Your data-variant-id radios/buttons
  // - Any custom variant:change events
  const selectors = [
    ...document.querySelectorAll('select[name="id"], input[name="id"]'),
    ...document.querySelectorAll("[data-variant-id]")
  ];
  selectors.forEach(el => {
    el.addEventListener("change", updateForActiveVariant);
    el.addEventListener("click",  updateForActiveVariant);
  });
  document.addEventListener("variant:change", updateForActiveVariant);

  // Do initial render
  updateForActiveVariant();
})();
